import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import { exibirMensagem } from '../../redux/actions/mensagemAction';
import ambiente from '../../config/ambienteConfig';
import PesosAtivosRow from './PesosAtivosRow';

class PesosAtivos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            chaves: {},
            ativo: '',
            ativos: [],
            pesos: {},
            tipo_atual: 'ACAO',
            pesos_correntes: [],
            somatoria: 0
        };
    }

    componentDidMount = async () => {
        try {
            this.acertarAtivosPeloTipo();

            const resPesos = await axios.get(`${ambiente.dev.server}/pesos_ativos`);
            resPesos.data.acoes.forEach(item => item.peso = parseFloat(item.peso) * 100);
            resPesos.data.fiis.forEach(item => item.peso = parseFloat(item.peso) * 100);
            resPesos.data.td.forEach(item => item.peso = parseFloat(item.peso) * 100);
            resPesos.data.rfixa.forEach(item => item.peso = parseFloat(item.peso) * 100);
            this.setState({ pesos: resPesos.data, pesos_correntes: resPesos.data.acoes });
            this.atualizarSomatoria();
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    acertarAtivosPeloTipo = async () => {
        const res = await axios.get(`${ambiente.dev.server}/ativos`);
        const chaves = {};
        const ativos = [];
        res.data.forEach(ativo => {
            if (ativo.tipo === this.state.tipo_atual) {
                chaves[ativo.id] = ativo.nome;
                ativos.push(ativo);
            }
        });
        this.setState({ ativos });
        if (ativos.length > 0) this.setState({ ativo: ativos[0].id });
        this.setState({ chaves });
    }

    handleSave = async () => {
        const pesosParaSalvar = [];
        this.state.pesos.acoes.forEach(item =>
            pesosParaSalvar.push({ ativo_id: item.ativo_id, peso: (parseFloat(item.peso) / 100) }));
        this.state.pesos.fiis.forEach(item =>
            pesosParaSalvar.push({ ativo_id: item.ativo_id, peso: (parseFloat(item.peso) / 100) }));
        this.state.pesos.td.forEach(item =>
            pesosParaSalvar.push({ ativo_id: item.ativo_id, peso: (parseFloat(item.peso) / 100) }));
        this.state.pesos.rfixa.forEach(item =>
            pesosParaSalvar.push({ ativo_id: item.ativo_id, peso: (parseFloat(item.peso) / 100) }));
        try {
            await axios.post(`${ambiente.dev.server}/pesos_ativos`, pesosParaSalvar);
            this.props.exibirMensagem('yay', `Pesos salvos com sucesso`);
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    handleRemove = async (ativo_id) => {
        const pesosAntigos = [...this.state.pesos_correntes];
        const pesos_correntes = pesosAntigos.filter(item => item.ativo_id !== ativo_id);
        const pesos = this.state.pesos;
        switch (this.state.tipo_atual) {
            case 'ACAO': pesos.acoes = pesos_correntes; break;
            case 'FII': pesos.fiis = pesos_correntes; break;
            case 'TDIR': pesos.td = pesos_correntes; break;
            case 'RFIXA': pesos.rfixa = pesos_correntes; break;
            default: break;
        }
        this.setState({ pesos, pesos_correntes });
        this.props.exibirMensagem('warn', `O item será removido de fato apenas após o salvamento.`);
        this.atualizarSomatoria();
    }

    addPeso = () => {
        const pesos_correntes = [...this.state.pesos_correntes];
        pesos_correntes.push({ ativo_id: this.state.ativo, peso: 0.0 });
        const pesos = this.state.pesos;
        switch (this.state.tipo_atual) {
            case 'ACAO': pesos.acoes = pesos_correntes; break;
            case 'FII': pesos.fiis = pesos_correntes; break;
            case 'TDIR': pesos.td = pesos_correntes; break;
            case 'RFIXA': pesos.rfixa = pesos_correntes; break;
            default: break;
        }
        this.setState({ pesos, pesos_correntes });
        this.atualizarSomatoria();
    }

    atualizarValor = (ativo_id, peso) => {
        const pesos_correntes = [...this.state.pesos_correntes];
        pesos_correntes.forEach(item => {
            if (item.ativo_id === ativo_id) {
                item.peso = peso;
            }
        });
        const pesos = this.state.pesos;
        switch (this.state.tipo_atual) {
            case 'ACAO': pesos.acoes = pesos_correntes; break;
            case 'FII': pesos.fiis = pesos_correntes; break;
            case 'TDIR': pesos.td = pesos_correntes; break;
            case 'RFIXA': pesos.rfixa = pesos_correntes; break;
            default: break;
        }
        this.setState({ pesos, pesos_correntes });
        this.atualizarSomatoria();
    }

    atualizarSomatoria = () => {
        let somatoria = 0;
        this.state.pesos_correntes.forEach(peso => somatoria += parseFloat(peso.peso) || 0);
        this.setState({ somatoria });
    }

    handleAcoesClicked = async () => {
        await this.setState({ tipo_atual: 'ACAO' });
        this.setState({ pesos_correntes: this.state.pesos.acoes });
        this.acertarAtivosPeloTipo();
        this.atualizarSomatoria();
    }

    handleFIIClicked = async () => {
        await this.setState({ tipo_atual: 'FII', pesos_correntes: this.state.pesos.fiis });
        this.acertarAtivosPeloTipo();
        this.atualizarSomatoria();
    }

    handleTDClicked = async () => {
        await this.setState({ tipo_atual: 'TDIR' });
        this.setState({ pesos_correntes: this.state.pesos.td });
        this.acertarAtivosPeloTipo();
        this.atualizarSomatoria();
    }

    handleRFClicked = async () => {
        await this.setState({ tipo_atual: 'RFIXA' });
        this.setState({ pesos_correntes: this.state.pesos.rfixa });
        this.acertarAtivosPeloTipo();
        this.atualizarSomatoria();
    }

    render() {
        return (
            <div>
                <div className="row">
                    <ul className="nav nav-tabs">
                        <li className="nav-item">
                            <a className={`nav-link ${this.state.active === 'ACAO' ? 'active' : ''}`} onClick={this.handleAcoesClicked}>Ações</a>
                        </li>
                        <li className="nav-item">
                            <a className={`nav-link ${this.state.active === 'FII' ? 'active' : ''}`} onClick={this.handleFIIClicked}>FIIs</a>
                        </li>
                        <li className="nav-item">
                            <a className={`nav-link ${this.state.active === 'TD' ? 'active' : ''}`} onClick={this.handleTDClicked}>TDireto</a>
                        </li>
                        <li className="nav-item">
                            <a className={`nav-link ${this.state.active === 'RF' ? 'active' : ''}`} onClick={this.handleRFClicked}>RFixa</a>
                        </li>
                    </ul>
                </div>
                <div className="row">
                    <div className="form-group col">
                        <select className="form-control" value={this.state.ativo} onChange={evt => this.setState({ ativo: evt.target.value })} autoFocus>
                            {this.state.ativos.map(item => <option key={item.id} value={item.id}>{item.nome}</option>)}
                        </select>
                    </div>
                    <div className="form-group col">
                        <button type="button" className="btn btn-primary btn-block"
                            onClick={this.addPeso} >
                            <i className="ffar fa-save" />
                        </button>
                    </div>
                </div>
                <button type="button" className="btn btn-primary btn-block" onClick={this.handleSave}>
                    Salvar
                </button>
                <div className="form-group col-10">
                    <input className="form-control" value={this.state.somatoria} />
                </div>
                <div className="list-group">
                    {this.state.pesos_correntes &&
                        this.state.pesos_correntes.map(item =>
                            <PesosAtivosRow nome={this.state.chaves[item.ativo_id]} key={item.ativo_id}
                                {...item} atualizarValor={this.atualizarValor} handleRemove={this.handleRemove} />)}
                </div>
            </div>
        );
    }
}

PesosAtivos.propTypes = {
    exibirMensagem: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PesosAtivos);



// WEBPACK FOOTER //
// ./src/components/pesos/PesosAtivos.js